import { useEffect, useState } from "react";

import { Box, Container, Grid, Paper, Tab, Tabs, Typography } from "@mui/material";

import PortfolioPurchaseFlow from "../../shared/purchase/PortfolioPurchaseFlow";
import SubscriptionsManagementTab from "./SubscriptionsManagementTab";

import FeatureErrorBoundary from "../../atoms/FeatureErrorBoundary";
import PortfoliosOptionsBar from "../../modules/projects/PortfoliosOptionsBar";
import PortfolioDisplayBlock from "../../modules/projects/PortfolioDisplayBlock";
import Link from "../../atoms/mui/Link";

import { analyticsPage, triggerGoogleEvent } from "../../../helpers/analytics";
import usePortfoliosContext, {
  PortfoliosContextProvider
} from "../../../helpers/contexts/offsetsPortfolios";
import usePlatformLayoutContext from "../../../helpers/contexts/platformLayout";

const CnaughtAttributionBanner = () => (
  <Box p={4}>
    <Container>
      <Paper>
        <Box p={2}>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <img
                alt="CNaught"
                src="/images/partner-logos/cnaught.svg"
                height={40}
              />
            </Grid>
            <Grid item>
              <Typography variant="body2">
                Carbon offsets powered by CNaught, a provider of science-backed
                carbon portfolios.
              </Typography>
              <Link href="https://www.cnaught.com/science-backed-portfolio">
                <Typography variant="body2">
                  Learn more about their approach
                </Typography>
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Container>
  </Box>
);

const PurchasePageBlock = () => {
  const { portfoliosLoading } = usePortfoliosContext();
  const { viewMode } = usePlatformLayoutContext();
  const [purchasePortfolio, setPurchasePortfolio] = useState(null);
  const [activeTab, setActiveTab] = useState("browse");

  useEffect(() => {
    analyticsPage("purchase");
    triggerGoogleEvent("view_item_list");
  }, []);

  if (portfoliosLoading) {
    return <></>;
  }

  const isBrowseTab = activeTab === "browse";

  return (
    <>
      {purchasePortfolio && (
        <PortfolioPurchaseFlow
          setPurchasePortfolio={setPurchasePortfolio}
          viewMode={viewMode}
        />
      )}
      <Box px={4} pt={2}>
        <Container>
          <Tabs
            value={activeTab}
            onChange={(_, newValue) => setActiveTab(newValue)}
            textColor="secondary"
            indicatorColor="secondary"
          >
            <Tab value="browse" label="Browse portfolios" />
            <Tab value="subscriptions" label="My subscriptions" />
          </Tabs>
        </Container>
      </Box>
      {isBrowseTab ? (
        <>
          <PortfoliosOptionsBar />
          <PortfolioDisplayBlock setPurchasePortfolio={setPurchasePortfolio} />
          <CnaughtAttributionBanner />
        </>
      ) : (
        <Box p={4}>
          <Container>
            <SubscriptionsManagementTab />
          </Container>
        </Box>
      )}
    </>
  );
};

const Purchase = () => (
  <FeatureErrorBoundary featureName="Carbon Offsets">
    <PortfoliosContextProvider displayPageUrl="/platform/company/purchase">
      <PurchasePageBlock />
    </PortfoliosContextProvider>
  </FeatureErrorBoundary>
);
export default Purchase;
